import React from 'react'
import styles from './segments.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Segments = ({ classes, className, children }) => (
  <div className={classNames(classes.container, className)}>{children}</div>
)

export default injectSheet(styles)(Segments)
